import type {
  RailwayBucketProvisionResult,
  RailwaySession
} from '@cli-types/next-adapter/railway.js'
import { spinner } from '@cli-utils/terminal.js'
import { provisionRailwayBucketResource } from './provision-railway-bucket-resource.js'

export async function ensureRailwayBucket(
  session: RailwaySession,
  cwd: string,
  options: { name?: string; region: string }
): Promise<RailwayBucketProvisionResult> {
  const name = options.name ?? 'media'
  const environmentArgs = ['--environment', session.project.environmentName]
  const provisionSpinner = spinner()
  provisionSpinner.start('Creating your Railway bucket')
  try {
    return await provisionRailwayBucketResource(session, cwd, name, options.region, environmentArgs)
  } finally {
    provisionSpinner.clear()
  }
}
